<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">Details needed in the SoW</h4>
      <small class="form-text text-muted"
        >For the selected lawfirm and incident type</small
      >
    </div>

    <div class="card-body">
      <h6 v-if="!template" class="error">
        No placeholders and master documents available for selected Lawfirm and
        Incident Type. Please configure.
      </h6>
      <div class="form-group" v-if="template">
        <label for="exampleInputEmail1">Signing Authority
          <span class="error" v-if="!selectedAuthority">
            *
          </span>
        </label>
        <select
          v-model="selectedAuthority"
          class="form-control"
          id="authority"
          aria-describedby="authorityHelp"
        >
          <option
            v-for="ser in authoritiesData"
            v-bind:key="ser.id"
            v-bind:value="ser.slug"
          >
            {{ ser.name }}
          </option>
        </select>
        <div class="error" v-if="!selectedAuthority">
          Please select a value for Signing Authority.
        </div>
      </div>
      <div
        class="form-group"
        v-if="
          template &&
          this.$store.getters.selectedProject == null &&
          (this.$store.getters.selectedIncidentType == 'it-ran-eve' ||
            this.$store.getters.selectedIncidentType == 'it-bus-ema-com' ||
            this.$store.getters.selectedIncidentType == 'it-extortion')&&
        this.$store.getters.selectedCountry != 'ctry-in-le'
        "
      >
        <div class="form-group" v-if="template">
          <label for="exampleInputEmail1">Rate Card<span class="error" v-if="!manualRateCardDetails.rateCard">
            *
          </span></label>
          <select
            v-model="manualRateCardDetails.rateCard"
            @change="selectRateCard(manualRateCardDetails.rateCard)"
            class="form-control"
            id="ratecard"
            aria-describedby="authorityHelp"
          >
            <option
              v-for="ser in rateCardsData"
              v-bind:key="ser.id"
              v-bind:value="ser.title"
            >
              {{ ser.title }}
            </option>
          </select>
          <div class="error" v-if="!manualRateCardDetails.rateCard">
            Please select a value for Rate Card.
          </div>
        </div>
        <div v-if="false">
          <label for="exampleInputEmail1">RateCard Id</label>
          <input
            type="text"
            class="form-control"
            @keyup="validRateCardId = true"
            @paste="validRateCardId = true"
            @keydown="validRateCardId = true"
            v-model="manualRateCardDetails.rateCardId"
          />
          <div class="error" v-if="!manualRateCardDetails.rateCardId">
            Please enter RateCard Id.
          </div>
          <div
            class="error"
            v-if="!$v.manualRateCardDetails.rateCardId.numeric"
          >
            Please enter valid Ratecard Id.
          </div>
          <div
            class="error"
            v-if="!validRateCardId && manualRateCardDetails.rateCardId"
          >
            Invalid rateCardId
          </div>
        </div>
      </div>
      <div
        class="form-group"
        v-if="
          template &&
          this.$store.getters.selectedProject == null &&
          (this.$store.getters.selectedIncidentType == 'it-ran-eve' ||
            this.$store.getters.selectedIncidentType == 'it-bus-ema-com' ||
            this.$store.getters.selectedIncidentType == 'it-extortion')&&
        this.$store.getters.selectedCountry != 'ctry-in-le'
        "
      >
        <label for="exampleInputEmail1"
          >Carrier<span class="error" v-if="!$v.manualRateCardDetails.carrier.required">
            *
          </span></label
        >
        <input
          type="text"
          class="form-control"
          v-model="manualRateCardDetails.carrier"
        />
        <div class="error" v-if="!$v.manualRateCardDetails.carrier.required">
          Please enter Carrier.
        </div>
      </div>
      <div
        class="form-group"
        v-bind:key="holder.slug"
        v-for="(holder, index) in $v.placeHolders.$each.$iter"
      >
        <!-- <div>{{ holder }}</div> -->
        <label v-bind:for="holder.$model.slug" :class="index"
          >{{ holder.$model.title }}
          <span class="error" v-if="!holder.defaultValue.isRequired">
            *
          </span></label
        >
        <div
          v-if="
            formatType(holder.$model.type) === 'Select' &&
            holder.$model.slug === 'lawfirmattorney'
          "
        >
          <select
            v-model="selectedAttorney"
            class="form-control"
            :id="holder.$model.slug"
            @change="selectedAttr(selectedAttorney)"
          >
            <option
              v-for="val in holder.$model.values"
              v-bind:key="val.name"
              v-bind:value="val.name"
            >
              {{ val.name }}
            </option>
          </select>
        </div>
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'clientname'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="holder.$model.defaultValue"
          :disabled="createAgainMode"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug !== 'clientname' &&
            holder.$model.slug !== 'lawfirmattentionemail' &&
            holder.$model.slug !== 'lawfirmattorneyaddress' &&
            holder.$model.slug !== 'attorneyaddresscity' &&
            holder.$model.slug !== 'attorneyaddressstate' &&
            holder.$model.slug !== 'attorneyaddresszip' &&
            holder.$model.slug !== 'lawfirmattorneytitle'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="holder.$model.defaultValue"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'lawfirmattorneytitle'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyTitle"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'lawfirmattorneyaddress'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyAddress"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'attorneyaddresscity'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyCity"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'attorneyaddressstate'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyState"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'attorneyaddresszip'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyZipCode"
        />
        <input
          class="form-control"
          v-if="
            formatType(holder.$model.type) === 'Text' &&
            holder.$model.slug === 'lawfirmattentionemail'
          "
          type="text"
          v-bind:id="holder.$model.slug"
          v-model="selectedAttorneyEmail"
        />

        <Datepicker
          v-if="
            formatType(holder.$model.type) === 'Date' &&
            holder.$model.slug === 'sowdate'
          "
          v-bind:id="holder.$model.slug"
          v-model="selectedSOWDate"
          format="MMMM d, yyyy"
          name="sowdate"
        ></Datepicker>

        <Datepicker
          v-if="
            formatType(holder.$model.type) === 'Date' &&
            holder.$model.slug === 'msadate'
          "
          v-bind:id="holder.$model.slug"
          v-model="selectedMSADate"
          format="MMMM d, yyyy"
          name="msadate"
        ></Datepicker>
        <Datepicker
          v-if="
            formatType(holder.$model.type) === 'Date' &&
            holder.$model.slug === 'effectivedate'
          "
          v-bind:id="holder.$model.slug"
          v-model="selectedEffectiveDate"
          format="MMMM d, yyyy"
          name="effectivedate"
        ></Datepicker>
        <select
          v-model="selectedValue"
          class="form-control"
          :id="holder.$model.slug"
          v-if="
            formatType(holder.$model.type) === 'Select' &&
            holder.$model.slug === 'term'
          "
        >
          <option
            v-for="val in JSON.parse(holder.$model.values)"
            v-bind:key="val"
            v-bind:value="val"
          >
            {{ val }}
          </option>
        </select>
        <select
          v-model="selectedTermsType"
          class="form-control"
          :id="holder.$model.slug"
          v-if="
            formatType(holder.$model.type) === 'Select' &&
            holder.$model.slug === 'termstype'
          "
          @change="selectedTermType(selectedTermsType)"
        >
          <option>MSA</option>
          <option>Terms of Service</option>
        </select>
        <small
          v-if="holder.$model.description"
          id="carrierHelp"
          class="form-text text-muted"
          >{{ holder.$model.description }}</small
        >
        <div class="error" v-if="!holder.defaultValue.isValid">
          Please enter a valid value for {{ holder.$model.title }}.
        </div>
        <div class="error" v-if="!holder.defaultValue.isRequired">
          Please enter a value for {{ holder.$model.title }}.
        </div>
      </div>
      <button class="btn btn-secondary" @click="goback">
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
        >Back
      </button>
      <button
        class="btn btn-info mx-2"
        v-bind:disabled="nextable"
        @click="gonext"
        v-if="template"
      >
        Next
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import { required, numeric, email, helpers } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
const phNo = helpers.regex("phNo", /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/);
const zipCode = helpers.regex("zipCode", /^\d{5}(-\d{4})?$/);
const canadazipCode = helpers.regex(
  "canadazipCode",
  /^[abceghjklmnprstvxy][0-9][abceghjklmnprstvwxyz]\s?[0-9][abceghjklmnprstvwxyz][0-9]$/i
);
const indiazipCode = helpers.regex("indiazipCode", /^[1-9][0-9]{5}$/i);
//Regex For Canada ZIP Validation - /^[abceghjklmnprstvxy][0-9][abceghjklmnprstvwxyz]\s?[0-9][abceghjklmnprstvwxyz][0-9]$/i

export default {
  name: "Placeholders",
  components: {
    Datepicker,
  },
  beforeMount() {
    var that = this;
    that.$root.$emit("stage", 2);
    //For filtering the attorneys corresponding to the lawfirm
    let lfMasterRecord = that.$store.getters.selectedLawfirmMasterRecord;
    that.selectedLawfirm = lfMasterRecord;
    let authorities = that.$store.getters.masterData.authorities;
    this.authoritiesData = authorities;
    this.rateCardsData = that.$store.getters.rateCards;
    if (
      (!that.$store.getters.hasTemplate &&
        that.$store.getters.selectedIncidentType != "it-mdr") ||
      (that.$store.getters.selectedIncidentType == "it-mdr" &&
        !that.$store.getters.hasMDRTemplate)
    ) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching Template",
        message: "Fetching the template for the selected lawfirm and services",
      });
      serviceProxy.template
        .getTemplate(
          this.$store.getters.token,
          this.$store.getters.selectedLawfirm,
          this.$store.getters.selectedSubofferingType
        )
        .then((response) => {
          let templateConfig = response.data.data;
          // templateConfig = templateConfig.length > 0 ? templateConfig[0] : {};
          // let carrierMasterRecord =
          //   that.$store.getters.selectedCarrierMasterRecord;
          if (templateConfig) {
            serviceProxy.template
              .getMasterTemplate(
                this.$store.getters.token,
                templateConfig.masterTemplate
              )
              .then((data) => {
                let mastertemplateConfig = data.data.data;
                mastertemplateConfig.placeHolders = _.filter(
                  mastertemplateConfig.placeHolders,
                  (pl) => pl.isActive
                );
                if (
                  this.$store.getters.newMdrRenewal &&
                  that.$store.getters.selectedIncidentType == "it-mdr" &&
                  !_.find(mastertemplateConfig.placeHolders, (phs) => {
                    return phs.slug === "termstype";
                  })
                ) {
                  mastertemplateConfig.placeHolders.push(this.termsType);
                }
                if (
                  (this.amendmentMode || this.$store.getters.newMdrRenewal) &&
                  that.$store.getters.selectedIncidentType == "it-mdr" &&
                  !_.find(mastertemplateConfig.placeHolders, (phs) => {
                    return phs.slug === "effectivedate";
                  })
                ) {
                  mastertemplateConfig.placeHolders.unshift(this.effectiveDate);
                }
                _.each(mastertemplateConfig.placeHolders, (holder) => {
                  let custval = that.$store.getters.selectedProject
                    ? _.find(
                        that.$store.getters.selectedProject.custom_field_values,
                        (selser) =>
                          selser.custom_field_id === holder.customField
                      )
                    : "";
                  let hubspotval =
                    that.$store.getters.selectedClient[holder.slug];
                  if (that.$store.getters.selectedProject) {
                    holder.defaultValue = holder.isCustomfield
                      ? custval
                        ? custval.display_value
                        : holder.defaultValue || ""
                      : holder.defaultValue || "";
                  } else {
                    holder.defaultValue = holder.isCustomfield
                      ? hubspotval
                      : holder.defaultValue || "";
                  }
                  if (holder.slug === "lawfirmname") {
                    holder.defaultValue = lfMasterRecord.title;
                  } else if (holder.slug === "lawfirmattorney") {
                    let attorneys = lfMasterRecord.attorneys;
                    holder.values = _.filter(
                      attorneys,
                      (at) => at.isActive == true
                    );
                  } else if (holder.slug === "clientname") {
                    holder.defaultValue = that.$store.getters.selectedClient
                      .name
                      ? that.$store.getters.selectedClient.name
                      : that.$store.getters.selectedManualClient;
                  }
                  // else if (holder.slug === "lawfirmaddress") {
                  //   holder.Values = _.find(
                  //     lfMasterRecord.Data,
                  //     d => d.Key === "Addresses"
                  //   ).Value;
                  // }
                  that.placeHolders.push(holder);
                });
                that.$store.commit(
                  "mastertemplateconfig",
                  mastertemplateConfig
                );
              });
          }
          // that.addresses = _.find(
          //   lfMasterRecord.Data,
          //   d => d.Key === "Addresses"
          // ).Value;
          that.template = templateConfig.slug;
          that.title = templateConfig.title;
          if (that.$store.getters.selectedIncidentType == "it-mdr") {
            that.$store.commit("mdrtemplateconfig", templateConfig);
          } else {
            that.$store.commit("templateconfig", templateConfig);
          }
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Fetched Template",
            message:
              "Fetched the template for the selected lawfirm and services",
          });
        })
        .catch((e) => {
          console.log(e);
          that.$root.$emit("done");
        });
    } else {
      if (that.$store.getters.newClientRateCardData) {
        this.manualRateCardDetails = that.$store.getters.newClientRateCardData;
        this.validRateCardId = true;
      }
      let mastertemplateConfig =
        that.$store.getters.selectedMasterTemplateConfig;
      if (
        this.amendmentMode &&
        that.$store.getters.selectedIncidentType !== "it-mdr" &&
        !_.find(mastertemplateConfig.placeHolders, (phs) => {
          return phs.slug === "amendmentcount";
        })
      ) {
        mastertemplateConfig.placeHolders.unshift({
          type: "Text",
          defaultValue: null,
          isReadonly: false,
          isOptional: false,
          slug: "amendmentcount",
          title: "Amendment Count",
          description: "",
          isActive: true,
          order: null,
        });
      }
      if (
        (this.amendmentMode || this.$store.getters.newMdrRenewal) &&
        that.$store.getters.selectedIncidentType == "it-mdr" &&
        !_.find(mastertemplateConfig.placeHolders, (phs) => {
          return phs.slug === "effectivedate";
        })
      ) {
        mastertemplateConfig.placeHolders.unshift(this.effectiveDate);
      }
      that.currentMsaFileInfo = mastertemplateConfig.msaFileInfo;
      // If there is no AmendmentFileId
      if (this.amendmentMode && !mastertemplateConfig.amendmentFileInfo) {
        serviceProxy.template
          .getMasterTemplate(
            this.$store.getters.token,
            this.$store.getters.selectedTemplateConfig.masterTemplate
          )
          .then((data) => {
            let response = data.data.data;
            mastertemplateConfig.amendmentFileInfo = response.amendmentFileInfo;
          });
      }
      _.each(mastertemplateConfig.placeHolders, (holder) => {
        holder.defaultValue = holder.defaultValue || "";
        that.placeHolders.push(holder);
      });
      that.template = mastertemplateConfig.slug;
      that.title = mastertemplateConfig.title;
      if ((that.selectedAuthority = that.$store.getters.selectedAuthority)) {
        that.selectedAuthority = that.$store.getters.selectedAuthority[0].slug;
      }
      _.each(that.$store.getters.placeholderValues, (storePh) => {
        let localPh = _.find(that.placeHolders, (localPh) => {
          return localPh.slug === storePh.slug;
        });
        if (localPh) {
          localPh.defaultValue = storePh.Value;
          if (localPh.slug === "lawfirmattorney") {
            that.selectedAttorney = localPh.defaultValue;
          } else if (localPh.slug === "lawfirmattorneytitle") {
            that.selectedAttorneyTitle = localPh.defaultValue;
          } else if (localPh.slug === "lawfirmattorneyaddress") {
            that.selectedAttorneyAddress = localPh.defaultValue;
          } else if (localPh.slug === "attorneyaddresscity") {
            that.selectedAttorneyCity = localPh.defaultValue;
          } else if (localPh.slug === "attorneyaddressstate") {
            that.selectedAttorneyState = localPh.defaultValue;
          } else if (localPh.slug === "lawfirmattentionemail") {
            that.selectedAttorneyEmail = localPh.defaultValue;
          } else if (localPh.slug === "attorneyaddresszip") {
            that.selectedAttorneyZipCode = localPh.defaultValue;
          } else if (localPh.slug === "msadate") {
            that.selectedMSADate = localPh.defaultValue;
          } else if (localPh.slug === "sowdate") {
            that.selectedSOWDate = localPh.defaultValue;
          } else if (localPh.slug === "effectivedate") {
            that.selectedEffectiveDate = localPh.defaultValue;
          } else if (localPh.slug === "term") {
            that.selectedValue = localPh.defaultValue;
          } else if (localPh.slug === "termstype") {
            that.selectedTermsType = localPh.defaultValue;
          }
        }
      });
    }
    if (!that.$store.getters.selectedAuthority) {
      let incidentTypes = that.$store.getters.masterData.incidentTypes;
      let selAuthority = _.filter(
        incidentTypes,
        (mr) => mr.slug == that.$store.getters.selectedIncidentType
      )[0].authority;
      that.selectedAuthority =
        that.$store.getters.selectedCountry.toUpperCase() == "CTRY-IN-LE"
          ? _.filter(
              this.authoritiesData,
              (mr) => mr.slug.indexOf("athry-rajsivaraju") > -1
            )[0].slug
          : selAuthority;
    }
  },
  methods: {
    formatType: function (value) {
      let that = this;
      let type = _.filter(that.placeholderoptions, (mr) => mr.value === value);
      return (value = type.length ? type[0].text : value);
    },
    goback: function (oEvent) {
      this.$router.go(-1);
    },
    gonext: function (oEvent) {
      /*
        1. Save the PlaceHolder Values - slug, Value
      */
      var that = this;
      let phValues = _.map(this.placeHolders, (ph) => {
        if (ph.slug === "lawfirmattorney") {
          ph.defaultValue = that.selectedAttorney;
        }
        // else if (ph.slug === "lawfirmattorneytitle") {
        //   ph.defaultValue = that.selectedAttorneyTitle;
        // }
        else if (ph.slug === "lawfirmattorneyaddress") {
          ph.defaultValue = that.selectedAttorneyAddress;
        } else if (ph.slug === "attorneyaddresscity") {
          ph.defaultValue = that.selectedAttorneyCity;
        } else if (ph.slug === "attorneyaddressstate") {
          ph.defaultValue = that.selectedAttorneyState;
        } else if (ph.slug === "lawfirmattentionemail") {
          ph.defaultValue = that.selectedAttorneyEmail;
        } else if (ph.slug === "attorneyaddresszip") {
          ph.defaultValue = that.selectedAttorneyZipCode;
        } else if (ph.slug === "lawfirmattorneytitle") {
          ph.defaultValue = that.selectedAttorneyTitle;
        } else if (ph.slug === "sowdate") {
          ph.defaultValue = that.selectedSOWDate;
        } else if (ph.slug === "msadate") {
          ph.defaultValue = that.selectedMSADate;
        } else if (ph.slug === "effectivedate") {
          ph.defaultValue = that.selectedEffectiveDate;
        } else if (ph.slug === "term") {
          ph.defaultValue = that.selectedValue;
        } else if (ph.slug === "termstype") {
          ph.defaultValue = that.selectedTermsType;
        }
        return {
          slug: ph.slug,
          Value: ph.defaultValue,
        };
      });
      if (this.amendmentMode) {
        let oldsowdate = _.filter(
          that.$store.getters.placeholderValues,
          (mr) => mr.slug === "msadate"
        );
        phValues = _.clone(_.union(phValues, oldsowdate));
      }
      if (
        this.amendmentMode &&
        that.$store.getters.selectedIncidentType == "it-mdr" &&
        !_.find(that.$store.getters.placeholderValues, (phs) => {
          return phs.slug === "termstype";
        })
      ) {
        phValues.push({
          slug: "termstype",
          Value: that.currentMsaFileInfo ? "MSA" : "Terms of Service",
        });
      }
      this.$store.commit("placeholders", phValues);
      let auth = _.filter(
        this.authoritiesData,
        (ad) => ad.slug === this.selectedAuthority
      );
      this.$store.commit("authorityData", {
        authority: auth,
      });
      this.$store.commit("newClientData", {
        rateCardDetails: this.manualRateCardDetails,
      });
      if (
        (this.$store.getters.selectedIncidentType == "it-ran-eve" ||
          this.$store.getters.selectedIncidentType == "it-bus-ema-com" ||
          this.$store.getters.selectedIncidentType == "it-extortion") &&
        this.$store.getters.selectedCountry != "ctry-in-le" &&
        this.$store.getters.selectedProject == null
      ) {
        this.$root.$emit("progress");
        serviceProxy.sow
          .validateRateCard(
            this.$store.getters.token,
            this.manualRateCardDetails.rateCardId
          )
          .then((data) => {
            var result = data.data.data;
            this.validRateCardId = true;
            this.$root.$emit("done");
            this.$router.push({ path: "fill-scope" });
          })
          .catch((e) => {
            this.$root.$emit("done");
            this.validRateCardId = false;
          });
      } else {
        this.$router.push({ path: "fill-scope" });
      }
      // this.$router.push({ path: "generate-mdr" });
    },
    mainzipCode: function (value) {
      return zipCode(value) || canadazipCode(value) || indiazipCode(value);
    },
    selectedAttr: function (val) {
      let defAttorneyTitle = _.find(this.placeHolders, (localPh) => {
        return localPh.slug === "lawfirmattorneytitle";
      });
      var attorneys = this.selectedLawfirm.attorneys;
      var attorney = _.find(attorneys, (a) => {
        return a.name === val;
      });
      if (attorney) {
        console.log(attorney);
        this.selectedAttorneyTitle = attorney.title
          ? attorney.title
          : defAttorneyTitle.defaultValue;
        this.selectedAttorneyAddress = attorney.streetAddress;
        this.selectedAttorneyCity = attorney.city;
        this.selectedAttorneyState = attorney.state;
        this.selectedAttorneyZipCode = attorney.zipCode;
        this.selectedAttorneyEmail = attorney.email;
      } else {
        this.selectedAttorneyTitle = "";
        this.selectedAttorneyAddress = "";
        this.selectedAttorneyCity = "";
        this.selectedAttorneyState = "";
        this.selectedAttorneyZipCode = "";
        // this.selectedAttorneyEmail = "";
      }
    },
    selectRateCard(val) {
      var ratecards = this.rateCardsData;
      var ratecard = _.find(ratecards, (a) => {
        return a.title === val;
      });
      this.manualRateCardDetails.rateCardId = ratecard.id;
    },
    selectedTermType: function () {
      if (
        this.selectedTermsType == "MSA" &&
        this.$store.getters.selectedIncidentType == "it-mdr" &&
        !_.find(this.placeHolders, (phs) => {
          return phs.slug === "msadate";
        })
      ) {
        this.placeHolders.push(this.msaDate);
        this.$store.getters.selectedMasterTemplateConfig.placeHolders.push(
          this.msaDate
        );
      } else if (
        this.selectedTermsType != "MSA" &&
        this.$store.getters.selectedIncidentType == "it-mdr" &&
        _.find(this.placeHolders, (phs) => {
          return phs.slug === "msadate";
        })
      ) {
        this.placeHolders.pop(this.msaDate);
        this.$store.getters.selectedMasterTemplateConfig.placeHolders.pop(
          this.msaDate
        );
      }
    },
  },
  computed: {
    nextable() {
      this.$v.placeHolders.$touch();
      if (
        this.$v.placeHolders.$invalid ||
        this.$v.selectedAuthority.$invalid ||
        ((this.$store.getters.selectedIncidentType == "it-ran-eve" ||
          this.$store.getters.selectedIncidentType == "it-bus-ema-com" ||
          this.$store.getters.selectedIncidentType == "it-extortion") &&
        this.$store.getters.selectedCountry != "ctry-in-le" &&
          this.$store.getters.selectedProject == null)
          ? this.$v.manualRateCardDetails.$invalid
          : false
      ) {
        return true;
      }
      var that = this;
      return !(
        _.filter(this.placeHolders, (ph) => {
          if (ph.slug === "lawfirmattorney") {
            if (!that.selectedAttorney) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "lawfirmattorneytitle") {
            if (!that.selectedAttorneyTitle) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "lawfirmattorneyaddress") {
            if (!that.selectedAttorneyAddress) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "attorneyaddresscity") {
            if (!that.selectedAttorneyCity) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "attorneyaddressstate") {
            if (!that.selectedAttorneyState) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "lawfirmattentionemail") {
            if (!that.selectedAttorneyEmail) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "attorneyaddresszip") {
            if (!that.selectedAttorneyZipCode) {
              return true;
            } else {
              return false;
            }
          } else if (ph.slug === "clientname") {
            if (ph.defaultValue === null || ph.defaultValue.trim() === "") {
              return true;
            } else {
              return false;
            }
          }
          return false;
          // if (ph.defaultValue === null || ph.defaultValue.trim() === "") {
          //   return true;
          // } else {
          //   return false;
          // }
        }).length === 0
      );
    },
  },
  // watch: {
  //   selectedAttorney: function(val) {
  //     var attorneys = _.find(
  //       this.selectedLawfirm.Data,
  //       d => d.Key === "Attorneys"
  //     );
  //     var attorney = _.find(attorneys.Value, a => a.Name === val);
  //     if (attorney) {
  //       console.log(attorney);
  //       //this.selectedAttorneyTitle = attorney.Title;
  //       this.selectedAttorneyAddress = attorney.AddressLine;
  //       this.selectedAttorneyCity = attorney.City;
  //       this.selectedAttorneyState = attorney.State;
  //       this.selectedAttorneyZipCode = attorney.ZipCode;
  //       this.selectedAttorneyEmail = attorney.Email;
  //     } else {
  //       //this.selectedAttorneyTitle = "";
  //       this.selectedAttorneyAddress = "";
  //       this.selectedAttorneyCity = "";
  //       this.selectedAttorneyState = "";
  //       this.selectedAttorneyZipCode = "";
  //       // this.selectedAttorneyEmail = "";
  //     }
  //   }
  // },
  filters: {},
  data() {
    return {
      validRateCardId: false,
      authoritiesData: [],
      rateCardsData: [],
      selectedAuthority: "",
      template: "",
      placeHolders: [],
      placeholderoptions: [
        { value: 0, text: "Text" },
        { value: 1, text: "Description" },
        { value: 2, text: "Select" },
        { value: 3, text: "Bool" },
        { value: 4, text: "Email" },
        { value: 5, text: "PhNo" },
        { value: 6, text: "Date" },
      ],
      title: "",
      placeHolderValues: [],
      addresses: [],
      selectedLawfirm: {},
      selectedAttorney: "",
      selectedAttorneyAddress: "",
      selectedAttorneyCity: "",
      selectedAttorneyState: "",
      selectedAttorneyZipCode: "",
      selectedAttorneyEmail: "",
      selectedAttorneyTitle: "",
      selectedSOWDate: "",
      selectedMSADate: "",
      selectedEffectiveDate: "",
      selectedTermsType: "",
      selectedValue: "",
      createAgainMode: this.$store.getters.createAgainMode,
      amendmentMode: this.$store.getters.amendmentMode,
      isManualClient: this.$store.getters.selectedManualClient ? true : false,
      currentMsaFileInfo: "",
      effectiveDate: {
        type: "Date",
        defaultValue: null,
        isReadonly: false,
        isOptional: false,
        slug: "effectivedate",
        title: "Effective Date",
        description: "",
        isActive: true,
        order: null,
      },
      termsType: {
        type: "Select",
        defaultValue: null,
        isReadonly: false,
        isOptional: false,
        slug: "termstype",
        title: "Terms Type",
        description: "",
        isActive: true,
        order: null,
      },
      msaDate: {
        type: "Date",
        defaultValue: null,
        isReadonly: false,
        isOptional: false,
        slug: "msadate",
        title: "MSA Date",
        description: "",
        isActive: true,
        order: null,
      },
      manualRateCardDetails: {
        rateCardId: null,
        carrier: null,
        rateCard: null,
      },
    };
  },
  validations: {
    selectedAuthority: {
      required,
    },
    manualRateCardDetails: {
      required,
      rateCardId: {
        required,
        numeric,
      },
      carrier: {
        required,
      },
    },
    placeHolders: {
      $each: {
        defaultValue: {
          isRequired(defaultValue, ph) {
            if (
              ph.slug === "lawfirmattorney" ||
              ph.slug === "lawfirmattorneytitle" ||
              ph.slug === "lawfirmattorneyaddress" ||
              ph.slug === "clientname" ||
              ph.slug === "attorneyaddresscity" ||
              ph.slug === "attorneyaddressstate" ||
              ph.slug === "lawfirmattentionemail" ||
              ph.slug === "attorneyaddresszip" ||
              ph.slug === "amendmentcount" ||
              ph.slug === "sownumber" ||
              ph.slug === "term" ||
              ph.slug === "termstype" ||
              (ph.slug === "sowdate" &&
                (this.$store.getters.selectedIncidentType == "it-mdr" ||
                  this.$store.getters.selectedSubofferingType ==
                    "stype-msp-con-acc-1-yea" ||
                  this.$store.getters.selectedSubofferingType ==
                    "stype-msp-con-acc-mtm")) ||
              (ph.slug === "effectivedate" &&
                this.$store.getters.selectedIncidentType == "it-mdr") ||
              (ph.slug === "msadate" &&
                this.$store.getters.selectedIncidentType == "it-mdr")
            ) {
              if (ph.slug === "lawfirmattorney") {
                if (this.selectedAttorney) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorney);
              } else if (ph.slug === "lawfirmattorneytitle") {
                if (this.selectedAttorneyTitle) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "lawfirmattorneyaddress") {
                if (this.selectedAttorneyAddress) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "attorneyaddresscity") {
                if (this.selectedAttorneyCity) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "attorneyaddressstate") {
                if (this.selectedAttorneyState) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "lawfirmattentionemail") {
                if (this.selectedAttorneyEmail) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "attorneyaddresszip") {
                if (this.selectedAttorneyZipCode) {
                  return true;
                } else {
                  return false;
                }
                //return required(this.selectedAttorneyTitle);
              } else if (ph.slug === "clientname") {
                if (ph.defaultValue === null || ph.defaultValue.trim() === "") {
                  return false;
                } else {
                  return true;
                }
                //return required(ph.defaultValue);
              } else if (ph.slug === "amendmentcount") {
                if (ph.defaultValue === null || ph.defaultValue.trim() === "") {
                  return false;
                } else {
                  return true;
                }
                //return required(ph.defaultValue);
              } else if (ph.slug === "sownumber") {
                if (ph.defaultValue === null || ph.defaultValue.trim() === "") {
                  return false;
                } else {
                  return true;
                }
                //return required(ph.defaultValue);
              } else if (ph.slug === "term") {
                if (this.selectedValue) {
                  return true;
                } else {
                  return false;
                }
                //return required(ph.defaultValue);
              } else if (ph.slug === "termstype") {
                if (this.selectedTermsType) {
                  return true;
                } else {
                  return false;
                }
                //return required(ph.defaultValue);
              } else if (
                ph.slug === "sowdate" &&
                (this.$store.getters.selectedIncidentType == "it-mdr" ||
                  this.$store.getters.selectedSubofferingType ==
                    "stype-msp-con-acc-1-yea" ||
                  this.$store.getters.selectedSubofferingType ==
                    "stype-msp-con-acc-mtm")
              ) {
                if (this.selectedSOWDate) {
                  return true;
                } else {
                  return false;
                }
                //return required(ph.defaultValue);
              } else if (
                ph.slug === "effectivedate" &&
                this.$store.getters.selectedIncidentType == "it-mdr"
              ) {
                if (this.selectedEffectiveDate) {
                  return true;
                } else {
                  return false;
                }
                //return required(ph.defaultValue);
              } else if (
                ph.slug === "msadate" &&
                this.$store.getters.selectedIncidentType == "it-mdr"
              ) {
                if (this.selectedMSADate) {
                  return true;
                } else {
                  return false;
                }
                //return required(ph.defaultValue);
              }
            } else {
              return true;
            }
          },
          isValid(defaultValue, placeHolder) {
            if (
              (defaultValue != null && defaultValue != "") ||
              placeHolder.slug === "attorneyaddresszip" ||
              placeHolder.slug === "lawfirmattentionemail"
            ) {
              if (placeHolder.slug === "attorneyaddresszip") {
                if (this.mainzipCode(this.selectedAttorneyZipCode)) {
                  return true;
                } else {
                  return false;
                }
              } else if (placeHolder.slug === "lawfirmattentionemail") {
                return email(this.selectedAttorneyEmail);
              } else if (placeHolder.slug.indexOf("email") != -1) {
                return email(defaultValue);
              } else if (placeHolder.slug.indexOf("contactnumber") != -1) {
                return phNo(defaultValue);
              } else if (placeHolder.slug.indexOf("zip") != -1) {
                if (this.mainzipCode(defaultValue)) {
                  return true;
                } else {
                  return false;
                }
              } else if (
                placeHolder.slug.indexOf("amendmentcount") != -1 ||
                placeHolder.slug.indexOf("number") != -1
              ) {
                return numeric(defaultValue);
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
        },
      },
    },
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.error {
  color: red;
  border-color: #fdd;
}
</style>


